import { getAxiosInstance } from '../blocks/axios/axiosFactory';
import { GetFaqRequest } from '../models/faq/GetFaqRequest';

const url = "/faq";

export default class FaqService {
    static get(request: GetFaqRequest) {
        return getAxiosInstance().get(`${url}/get`, { params: { ...request } });
    }
}